// extracted by mini-css-extract-plugin
export default {"grey900":"#583b05","grey700":"#865f19","grey400":"#e2be7e","grey300":"#f7d59c","grey100":"#fff1dc","error900":"#d65385"};